'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import RoundedButton, {
  type RoundedButtonProps,
} from '@/shared/components/buttons/rounded-button'

export default function EdFloatingContinueButton(props: RoundedButtonProps) {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    // Keep the button tied to the viewport even inside an animated quiz screen.
    setPortalTarget(document.body)
  }, [])

  return portalTarget
    ? createPortal(
        <div
          className="pointer-events-none fixed inset-x-0 bottom-0 z-20 bg-gradient-to-t from-white from-40% to-transparent pt-11"
          style={{ paddingBottom: 'max(24px, env(safe-area-inset-bottom))' }}
        >
          <div className="pointer-events-auto mx-auto max-w-3xl px-6 sm:px-8 lg:px-10">
            <RoundedButton
              type="button"
              className="min-h-11 whitespace-nowrap leading-5"
              {...props}
            />
          </div>
        </div>,
        portalTarget,
      )
    : null
}
